
export default {
  props: {
    mailData: {},
    buyData: {},
  },
  data() {
    return {
      objStyle: {
        fontWeight: 'bold',
        backgroundColor: '#efefef',
      },
    }
  },
}
